/**
 * Payment Method Update Token Provider Request Class
 * Definition for updating payment method token provider
 *
 * @author Ariel Pérez
 */

import { AddressRequest } from './payment-iframe-types';

export interface Deserializable {
  deserialize(input: any): this;
}

export class PaymentMethodUpdateTokenProviderRequest implements Deserializable {
  public id: number | null;
  public token: string | null;
  public cardNumber: string | null;
  public cvc: string | null;
  public expirationMonth: number | null;
  public expirationYear: number | null;
  public sourceUserId: number | null;
  public sourceBusinessId: number | null;
  public stripeCustomerId: string | null;
  public billingAddress: AddressRequest | null;
  public cardAgreement: Record<string, unknown> | null;
  public cardHolderFirstName: string | null;
  public cardHolderLastName: string | null;

  constructor() {
    this.id = null;
    this.token = null;
    this.cardNumber = null;
    this.cvc = null;
    this.expirationMonth = null;
    this.expirationYear = null;
    this.sourceUserId = null;
    this.sourceBusinessId = null;
    this.stripeCustomerId = null;
    this.billingAddress = null;
    this.cardAgreement = null;
    this.cardHolderFirstName = null;
    this.cardHolderLastName = null;
  }

  /**
   * Implementation of the interface to serialize json plain objects
   *
   * @param input the data object
   * @return Result
   */
  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}


